import { boot } from '@dazn/bootstrap-lib';
import pubby, { EventType } from '@dazn/pubby-client';

export interface CreatePubbyModuleProps {
    getStartupData: () => boot.startupData.StartupData;
    getUserToken: () => string;
}

export const createPubbyModule = ({
    getStartupData,
    getUserToken,
}: CreatePubbyModuleProps) => ({
    run: () => {
        const userToken = getUserToken();
        const debounceDelay = 500;
        // Configure pubby if it's not already and user is logged in.
        if (!pubby.isConfigured && userToken) {
            pubby.configure(getStartupData()?.ServiceDictionary?.Pubby);
            setTimeout(() => {
                pubby.auth(userToken);
            }, debounceDelay);
        }
    },

    subscribePubbyRoom: (
        consumerId: string,
        room: string,
        dump: boolean,
        onMessage: (
            id: string,
            data: any,
            version: number,
            dumped: boolean,
        ) => void,
    ) => {
        const userToken = getUserToken();
        if (userToken) {
            pubby.auth(userToken);
        }

        pubby.subscribe(consumerId, room, dump, onMessage);
    },

    unsubscribePubbyRoom: (consumerId: string, room: string) => {
        pubby.unsubscribe(consumerId, room);
    },

    authenticatePubby(token: string) {
        if (!pubby.isConfigured) {
            const debounceDelay = 500;
            pubby.configure(getStartupData()?.ServiceDictionary?.Pubby);
            setTimeout(() => {
                pubby.auth(token);
            }, debounceDelay);
        } else {
            pubby.auth(token);
        }
    },
    getPubbyEventTypes: () => EventType,
    addPubbyEventListener: pubby.addEventListener,
    removePubbyEventListener: pubby.removeEventListener,
});
